import React from "react";
import { Container } from "react-bootstrap";

import Map from "../../../../components/Map/Map";
import "./LisbonMap.scss";

function LisbonMap() {
  return (
    <div className="lisbon-map section" id="lisbon-map">
      <Container>
        <div className="main-heading">
          <h1>Find Closest Recycle Bin to You</h1>
          <p>Explore the map to locate nearby recycling bins.</p>
        </div>
        <Map />
      </Container>
    </div>
  );
}

export default LisbonMap;
